import request from '@/utils/request'

const api = {
    homepage: {
        technicalServise: (params) => request.get(`/v1/goods/category/recommend`, params),
        banner: (params) => request.get(`/v1/banner`, params),
        productCenter: () => request.get(`/v1/goods/category/recommend`),
        service: () => request.get(`/v1/service/recommend`),
        news: () => request.get(`/v1/article/recommend`),
        brandAll:()=> request.get('/v1/goods/brand'),
        brandFilterAll:() => request.get('/v1/goods/brand/arr'),
        brandDetail:(params) => request.get('/v1/goods/brand'+'/'+ params),
        technicalservice: (params) => request.post('/v1/technical/service', params),
    },
    news: {
        newsList: (params) => request.get('/v1/article', params),
        newsClassify: () => request.get('/v1/article/category'),
        newsDetail: (params) => request.get('/v1/article/details', params)
    },
    technicalServise: {
        serviseList: () => request.get('/v1/service'),
        serviceDetail: (params) => request.get('/v1/service/details', params)
    },
    main: {
        register: (params) => request.post(`/v1/user/register`, params),
        login: (params) => request.post(`v1//user/login`, params),
        loginout: () => request.post('/v1//user/logout'),
        active: (params) => request.post('/v1/user/active', params),
        forgetword: (params) => request.post('/v1/user/forget', params),
        useSet: (params) => request.post('/v1/user/reset', params)
    },
    productCenter: {
        getShopData: (params) => request.get(`/v1/goods`, params),
        getproduct: (params) => request.get('/v1/goods/category', params),
        search: (params) => request.get(`/v1/goods/search`, params),
        goodsDetail: (params) => request.get('/v1/goods/details', params),
        tryGoodsList: () => request.get('/v1/goods/trial'),
        skuList: (params) => request.get('/v1/sku', params)
    },
    technicalSupports: {
        msds: (params) => request.get('/v1/msds', params),
        coa: (params) => request.get('/v1/coa', params),
        instructions: (params) => request.get('/v1/instructions', params),
        getlearningdata:(params) => request.get(`/v1/technicalArticle`, params),
        getlearningDetail:(params) => request.get(`/v1/technicalArticle/details`, params),
    },
    personalInfo: {
        changePassword: (params) => request.post('/v1/user/password', params),
        getuser: () => request.get('/v1/user'),
        changeUserinfo: (params) => request.post('/v1/user/save', params),
    },
    shopCar: {
        carlist: (params) => request.get(`/v1/cart`, params),
        addcar: (params) => request.post(`/v1/cart/add`, params),
        updatecar: (params) => request.post(`/v1/cart/update`, params),
        deletecar: (params) => request.post(`/v1/cart/delete`, params),
        clearcar: (params) => request.post(`/v1/cart/clear`, params),
        AllNum: () => request.get('/v1/cart/count')
    },
    address: {
        district: (params) => request.get(`/v1/district`, params),
        addressList: () => request.get(`/v1/address`),
        addAddress: (params) => request.post(`/v1/address/add`, params),
        changeAddress: (params) => request.post(`/v1/address/edit`, params),
        detailAddress: (params) => request.get(`/v1/address/details`, params),
        delete: (params) => request.post('/v1/address/delete', params)
    },
    joinus: {
        job: () => request.get('/v1/job')
    },
    order: {
        submit: (params) => request.post('/v1/order/add', params),
        orderList: (params) => request.get('/v1/order', params),
        getOrderDetail: (params) => request.get('/v1/order/details', params),
        cancelOrder: (params) => request.post('/v1/order/cancel', params),
        salesReturn: (params) => request.get('/v1/order/aftersale', params),
        addAftersale: (params) => request.post('/v1/aftersale/add', params),
        cancelOne:(params) => request.post('/v1/aftersale/goods/cancel',params),
        recanceld:(params) => request.post('/v1/aftersale/goods/do/cancel',params)
    },
    invoice: {
        invoiceAddressList: () => request.get('/v1/invoice/address'),
        addinvoiceAddress: (params) => request.post('/v1/invoice/address/add', params),
        editinvoiceAddress: (params) => request.post('/v1/invoice/address/edit', params),
        invoiceAddressDetail: (params) => request.get('/v1/invoice/address/details', params),
        deleteinvoiceAddress: (params) => request.post('/v1/invoice/address/delete', params),
        getinvoice: () => request.get('/v1/invoice'),
        saveinvoice: (params) => request.post('/v1/invoice/save', params)
    },
    singlePage: {
        page: (params) => request.get('/v1/html', params)
    },
    payload: {
        orderPayInfo: (params) => request.get('/v1/order/pay', params),
        pay: (params) => request.post('/v1/pay', params)
    },
    balance: {
        balanceList: () => request.get('/v1/user/balance'),
        creditBalance: () => request.get('/v1/user/credit')
    },
    tryApply: {
        applySubmit: (params) => request.post('/v1/trial', params),
        applyList: (params) => request.get('/v1/trial', params),
        applyDetail: (params) => request.get('/v1/trial/details', params),
        afterSaleList: (params) => request.get('/v1/aftersale', params),
        lookOver: (params) => request.get('/v1/aftersale/detail', params),
        revocation: (params) => request.post('/v1/aftersale/cancel', params),
        cancelList:(params) => request.get('/v1/aftersale/goods/cancel',params)
    }
}

export default api
